enum SizeSelectionEnum {
  SizingKit = 'sizing-kit',
  ChooseSize = 'choose-size',
}

export default SizeSelectionEnum;
